import {txt} from '../i18n/idioma';

// Notas (i) del planeador semanal (decision 0063).
export const AYUDA_PLANEADOR = {
  tipo: txt(
    'Qué operación es: Llenado (de una exportación), Descargue CM (Colombian Mint y Mona Minas, no se discrimina), Descargue MA (Mineros), Antonov (avión con Big Bags de Mineros de alto tenor), Muestreo, Furgón 1 TON, los descargues QU, MSA, MNS e IPM, u Otra.',
    'Which operation it is: Filling (of an export), CM unloading (Colombian Mint and Mona Minas, not told apart), MA unloading (Mineros), Antonov (plane with high-grade Mineros Big Bags), Sampling, 1-ton van, QU, MSA, MNS and IPM unloadings, or Other.',
  ),
  exportacion: txt(
    'La exportación que se llena. Salen las propias y las de Mineros que todavía no han salido de la bodega, con su ETD. Si no está, déjala vacía y escríbela en la referencia.',
    'The export being filled. Own and Mineros exports that have not left the warehouse yet are listed, with their ETD. If it is not there, leave it empty and write it in the reference.',
  ),
  referencia: txt(
    'Lo que acompaña a la operación: la exportación como se escribe (MA014, CM -189), el lote o el número del descargue.',
    'What goes with the operation: the export as it is written (MA014, CM -189), the lot or the unloading number.',
  ),
  cuenta: txt(
    'Cuántas de las 8 operaciones del día ocupa. Casi siempre 1; un muestreo grande puede ocupar 2.',
    'How many of the 8 daily operations it takes. Almost always 1; a large sampling can take 2.',
  ),
  capacidad: txt(
    'Cuántas operaciones caben en un día en la bodega (hoy 8). Un día que se pasa sale en rojo, pero se puede guardar.',
    'How many operations fit in a day at the warehouse (8 today). A day that goes over shows in red, but it can be saved.',
  ),
  sobreMaximo: txt(
    'Días de la semana con más operaciones que el máximo por día.',
    'Days of the week with more operations than the daily maximum.',
  ),
};
